import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Head } from '@/components/ui/Typography/Heading/Head';
/** 色 */
const colors = {
    normal: {
        border: 'after:bg-turquoise-blue-100',
        text: 'primary',
    },
    white: {
        border: 'after:bg-gray-50',
        text: 'white',
    },
};
/** サイズ */
const sizes = {
    md: clsx('text-head-md lg:text-[32px] tracking-[0.4px] lg:tracking-[0.64px]', 'pb-[13px] lg:pb-[17px]'),
    sm: clsx('text-head-md tracking-[0.4px]', 'pb-[13px]'),
};
/**
 * TOP ページ Section ごとの見出し
 * @param props
 * @returns
 */
export const TopSectionHead = (props) => {
    const { children, className = '', color = 'normal', size = 'md' } = props;
    return (_jsx(Head, Object.assign({ className: clsx(sizes[size], 'text-center tracking-[0.4px]', 'relative', 'after:content-[""] after:block', 'after:absolute after:bottom-0 after:left-[calc(50%_-_32px)]', 'after:w-[64px] after:h-[2px]', colors[color].border, className), color: colors[color].text, size: 'none' }, { children: children })));
};
